import { Button, Input, Space } from "antd";
import CustomIcon from "../../layouts/CustomIcon";

export default function SeatChange({
  min = 0,
  max = 0,
  value = 0,
  size = "small",
  disabled = false,
  onChange = () => {},
  showWarning = false,
  allowMinDecrease = false,
}) {
  const handleChange = (newValue) => {
    const parsedValue = Math.abs(parseInt(newValue, 10)) || 0;

    if (allowMinDecrease) onChange(parsedValue);
    else onChange(parsedValue > max ? max : parsedValue < min ? min : parsedValue);
  };

  const handleIncrement = () => handleChange(value + 1);
  const handleDecrement = () => handleChange(value - 1);

  return (
    <Space.Compact className={`br-8px border-${showWarning ? "FAAF00" : "E3E8EF"}`}>
      <Button
        type='text'
        size={size}
        onClick={handleDecrement}
        className='border-right-none'
        icon={<CustomIcon name='minus' />}
        disabled={(!allowMinDecrease && value <= min) || value <= 0 || disabled}
      />
      <Input
        min={min}
        max={max}
        size={size}
        value={value}
        disabled={disabled}
        onChange={(e) => handleChange(e.target.value)}
        className='shadow-none border-none text-center fw-500 font-size-16px'
      />
      <Button
        type='text'
        size={size}
        onClick={handleIncrement}
        className='border-left-none'
        icon={<CustomIcon name='plus' />}
        disabled={(!allowMinDecrease && value >= max) || disabled}
      />
    </Space.Compact>
  );
}
